import { useEffect, useRef } from 'react';

import { startPeriodicRead } from '../lib/net/periodicRead';

/**
 * Re-read `read` every `everyMs` while the page is awake, and once at the wake (tab seen again,
 * network back) — see `startPeriodicRead`. `everyMs` null or ≤ 0: no polling. The latest `read`
 * rendered is always the one called, so a new callback does not restart the timer.
 */
export function usePeriodicRead(read: () => void, everyMs: number | null): void {
  const latest = useRef(read);
  useEffect(() => {
    latest.current = read;
  }, [read]);

  useEffect(() => {
    if (everyMs === null || everyMs <= 0) return undefined;
    return startPeriodicRead({ everyMs, read: () => latest.current() });
  }, [everyMs]);
}
